import { MenuItemType } from './types'

export const isMenuCta = (item: MenuItemType) =>
  ['prodotti-all', 'soluzioni-all', 'azienda-all', 'sostenibilita-all'].includes(item.key)
